package org.example.project.game

import kotlinx.serialization.Serializable

@Serializable
data class LangPack(
    val finalSolution: String = "",
    val hintsA: List<String> = emptyList(),
    val hintsB: List<String> = emptyList(),
    val hintsC: List<String> = emptyList(),
    val hintsD: List<String> = emptyList(),
    val solA: String = "",
    val solB: String = "",
    val solC: String = "",
    val solD: String = ""
)

@Serializable
data class FirebaseLevel(
    val difficulty: String = "easy",
    val translations: Map<String, LangPack> = emptyMap()
)

data class GameField(val id: String, val hintText: String, val isRevealed: Boolean = false)

data class GameColumn(
    val id: String,
    val fields: List<GameField>,
    val columnSolution: String,
    val isSolved: Boolean = false,
    val isHinted: Boolean = false
)

data class GameState(
    val columns: List<GameColumn>,
    val finalSolution: String,
    val isGameWon: Boolean = false,
    val isSurrendered: Boolean = false, // NEU: Speichert, ob aufgegeben wurde
    val currentScore: Int = 0
)

fun LangPack.toColumns(): List<GameColumn> = listOf(
    GameColumn("A", hintsA.mapIndexed { i, t -> GameField("A${i + 1}", t) }, solA),
    GameColumn("B", hintsB.mapIndexed { i, t -> GameField("B${i + 1}", t) }, solB),
    GameColumn("C", hintsC.mapIndexed { i, t -> GameField("C${i + 1}", t) }, solC),
    GameColumn("D", hintsD.mapIndexed { i, t -> GameField("D${i + 1}", t) }, solD),
)